import { format } from 'date-fns';
import { client } from '../../../../services/apiClient';
import { MonitorDataResponse } from '../../../../models/monitor/MonitorDataResponse';
import { getDefaultRange } from '../../../../utils/utils';
import { MonitorType } from '../../../../types/monitor/MonitorType';
import { MonitorPeriod } from '../../../../types/monitor/MonitorPeriod';

const DATA_ENDPOINT = '/monitor/data';

export const getMonitorData = async (
  monitorId: number,
  keyword: string,
  period: MonitorPeriod,
  type: MonitorType,
  from: Date | string | null,
  to: Date | string | null,
  page?: number,
  pageSize?: number,
  withContent?: boolean,
  forDate?: string,
  models?: string[]
): Promise<MonitorDataResponse> => {
  const defaultRange = getDefaultRange();
  from = from ?? defaultRange[0];
  to = to ?? defaultRange[1];

  const formattedFrom = from instanceof Date ? format(from, 'yyyy-MM-dd') : from;
  const formattedTo = to instanceof Date ? format(to, 'yyyy-MM-dd') : to;

  const pageParam = page !== undefined && page !== null ? page : 1;
  const pageSizeParam = pageSize !== undefined && pageSize !== null ? pageSize : 10;

  const queryParams = new URLSearchParams();
  queryParams.append('page', pageParam.toString());
  queryParams.append('pageSize', pageSizeParam.toString());

  if (withContent) {
    queryParams.append('withContent', '1');
  }

  if (forDate) {
    queryParams.append('forDate', forDate);
  }

  if (keyword) {
    queryParams.append('keyword', keyword);
  }

  if (models && models.length > 0) {
    queryParams.append('models', models.join(','));
  }

  const queryString = queryParams.toString();
  const { data } = await client(true, true).get<MonitorDataResponse>(
    `${DATA_ENDPOINT}/list/${monitorId}/${period}/${type}/${formattedFrom}/${formattedTo}/${
      queryString ? `?${queryString}` : ''
    }`
  );

  return data;
};

export const exportMonitorData = async (
  monitorId: number,
  period: MonitorPeriod,
  type: MonitorType,
  from?: Date | null,
  to?: Date | null,
  keyword?: string
): Promise<Blob> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const keywordParam = keyword ? `?keyword=${encodeURIComponent(keyword)}` : '';

  const { data } = await client(true, true).get<Blob>(
    `${DATA_ENDPOINT}/export/${monitorId}/${period}/${type}/${formattedFrom}/${formattedTo}${keywordParam}`,
    {
      responseType: 'blob',
    }
  );

  return data;
};
